import { DefaultService } from '@/services/DefaultService';

export default class ContrasenhaService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env);
    }
    
    save(user) {
        return this._http.post(`${this._env}/config/contrasenha`, user, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}